/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Table } from "../components";
import PropTypes from "prop-types";
import { List } from "immutable";
import {
    Row,
    Col,
    Input,
    Button,
    Select,
    Modal,
    message,
    Drawer,
    Timeline,
    Tag
} from "antd";
import { ADHOC_PARAMETERS_COLS } from "constants/table-columns";
import { CompanyService } from "../services";
import SingleDayNotes from "../templates/single-day-notes";
import { formatCurrency } from "utilities/currency";
import moment from "moment";
const { TextArea } = Input;
const { Option } = Select;

class AdhocTable extends Component {
  state = {
      columns: this.props.columns,
      showAssignModal: false,
      showOpenModal: false,
      requestIdVal: null,
      selectedAgent: "",
      selfAssignId: List(),
      remarksAssignCase: "",
      remarksOpenCase: "",
      page_size: 10,
      page: 1,
      facilityValues: {},
      expandedRow: null,
      showDrawer: false,
      getCaseCommentsData: [],
      isSubmitting: false
  };

  selectedRows = List();

  componentDidMount() {
      const userPermissions = (this.props.permissions.get("page_adhoc_edit") || this.props.permissions.get("page_adhoc_bulk_assign"));
      if (this.props.selectedTab === "requested" && userPermissions) {
          this.setState({
              columns: this.props.columns.set("action", {
                  title: "Action",
                  dataIndex: "action",
                  key: "action",
                  align: "center",
                  width: 100,
                  render: (value, record) => (
                      <Button
                          type={"link"}
                          onClick={() =>
                              this.selfAssignCase(List([record?.open_action_task?.id]))
                          }
                      >
              Assign
                      </Button>
                  ),
              }),
          });
      }
      if (this.props.showOpen) {
          this.setState({
              columns: this.props.columns.set("action", {
                  title: "Action",
                  dataIndex: "action",
                  key: "action",
                  width: 100,
                  render: (value, record) => (
                      <Button
                          type={"link"}
                          onClick={() => this.openCaseFn(record?.id)}
                      >
              Open
                      </Button>
                  ),
              }),
          });
      }
  }

  componentDidUpdate(prevProps) {
      const { expandableDetails } = this.props;
      if (expandableDetails !== prevProps.expandableDetails) {
          const facilityIds =
              expandableDetails?.extra_data?.json_obj?.facility_id?.split("|") || [];
          const facilityValues = facilityIds.map(() => "");
          this.setState({ facilityValues });
      }
  }

  openCaseFn = (request_id) => {
      this.setState({ showOpenModal: true, requestIdVal: request_id });
  };

  onRowSelection = (_) => {
      let filterTotalRow = _.filter((_) => _);
      this.selectedRows = filterTotalRow;
      this.forceUpdate();
  };

  selfAssignCase = (id) => {
      this.selectedRows = List();
      this.setState({
          selfAssignId: id,
          showAssignModal: !this.state.showAssignModal,
          selectedAgent: "",
          remarksAssignCase: "",
      });
  };

  openRejectedCase = () => {
      if(this.state.remarksOpenCase){
          this.state.requestIdVal &&
      CompanyService.adhocOpenCaseApi(
          this.state.requestIdVal,
          this.state.remarksOpenCase
      ).then((res) => {
          message.success(res && res.data && res.data.message || "Successful" );
          this.setState({showOpenModal:false});
      }).catch((err)=>{
          message.error(err && Object.values(err)[0] || "Something went wrong");
      });
      }
      else{
          message.error("Please fill the remarks");
      }
  }
  handleAssignCaseModal = () => {
      this.setState({
          showAssignModal: !this.state.showAssignModal,
          selectedAgent: "",
          remarksAssignCase: "",
          selfAssignId: "",
      });
  };
  handleOpenCaseModal = () => {
      this.setState({
          showOpenModal: !this.state.showOpenModal,
          remarksOpenCase: "",
          requestIdVal: null,
      });
  };

  assignBulkCase = () => {
      if (this.state.isSubmitting) {
          return;
      }
      this.setState({ isSubmitting: true });
      const user =
      this.selectedRows.size >= 1
          ? this.state.selectedAgent
          : this.props.userId;
      if(this.state.remarksAssignCase?.trim()?.length>0){
          CompanyService.bulkAssignCases(
              this.state.selfAssignId.isEmpty
                  ? this.state.selfAssignId
                  : this.selectedRows,
              this.state.remarksAssignCase,
              user
          )
              .then((res) => {
                  this.setState({ isSubmitting: false });
                  this.props.updateTable();
                  this.handleAssignCaseModal();
                  this.selectedRows = List();
                  res.status === 200 &&
          message.success(res.data || "Successfully Assigned");
                  this.setState({ remarksAssignCase: "", selectedAgent: "" });
              })
              .catch((err) => {
                  this.setState({ isSubmitting: false });
                  message.error("Something went wrong");
              });
      }else{
          this.setState({ isSubmitting: false });
          message.error("Please fill remarks");
      }
  };

  assignCasesModal = () => {
      const userDetails = this.props.userDetails;
      return (
          <Modal
              title="Assign Cases"
              visible={this.state.showAssignModal}
              onOk={this.handleAssignCaseModal}
              onCancel={this.handleAssignCaseModal}
              destroyOnClose={true}
              closable={true}
              footer={null}
          >
              <div className="d-flex flex-column justify-content-center align-items-center">
                  {this.selectedRows.size >= 1 && (
                      <Select
                          className="w-100 mb-10"
                          placeholder="Select Agent"
                          onChange={(_) => this.setState({ selectedAgent: _ })}
                          value={this.state.selectedAgent || null}
                      >
                          {this.props.usersList &&
                this.props.usersList.map((_, k) => (
                    <Option value={_.id} key={k}>
                        {_.full_name}
                    </Option>
                ))}
                      </Select>
                  )}
                  {this.selectedRows.size === 0 && (
                      <Select
                          className="w-100 mb-10"
                          placeholder="Select Agent"
                          disabled
                          value={`${userDetails?.first_name + " " + userDetails?.last_name}` || null}
                      >
                          {this.props.usersList &&
                this.props.usersList.map((_, k) => (
                    <Option value={_.id} key={k}>
                        {_.full_name}
                    </Option>
                ))}
                      </Select>
                  )}
                  <TextArea
                      placeholder="Remarks"
                      rows={4}
                      className="mb-10"
                      value={this.state.remarksAssignCase}
                      onChange={(e) =>
                          this.setState({ remarksAssignCase: e.target.value })
                      }
                  />
                  <Button
                      type="primary"
                      style={{ width: "25%", height: "2rem" }}
                      onClick={this.assignBulkCase}
                  >
            Submit
                  </Button>
              </div>
          </Modal>
      );
  };
  openCasesModal = () => {
      return (
          <Modal
              title="Open Case"
              visible={this.state.showOpenModal}
              onOk={this.handleOpenCaseModal}
              onCancel={this.handleOpenCaseModal}
              destroyOnClose={true}
              closable={true}
              footer={null}
          >
              <div className="d-flex flex-column justify-content-center align-items-center">
                  <TextArea
                      placeholder="Remarks"
                      rows={4}
                      className="mb-10"
                      value={this.state.remarksOpenCase}
                      onChange={(e) => this.setState({ remarksOpenCase: e.target.value })}
                  />
                  <Button
                      type="primary"
                      style={{ width: "25%", height: "2rem" }}
                      onClick={() => this.openRejectedCase()}
                  >
            Submit
                  </Button>
              </div>
          </Modal>
      );
  };
  handleFacilityChange = (idx, value) => {
      const facilityValues = { ...this.state.facilityValues };
      facilityValues[idx] = value;
      this.setState({ facilityValues });
  };

  expandedRowRender = (expandableDetails, record) => {
      const NEW_ADHOC_PARAMETERS_COLS = ADHOC_PARAMETERS_COLS.map((el) => {
          const json_update_creation_date = Array.isArray(
        expandableDetails?.extra_data?.json_update_creation_date
          )
              ? moment(expandableDetails?.extra_data?.json_update_creation_date[0]).format("DD/MM/YY")
              : expandableDetails?.extra_data?.json_update_creation_date
                  ? moment(expandableDetails?.extra_data?.json_update_creation_date).format("DD/MM/YY")
                  : "--";

          const json_creation_date = Array.isArray(
        expandableDetails?.extra_data?.json_creation_date
          )
              ? moment(expandableDetails?.extra_data?.json_creation_date[0]).format("DD/MM/YY")
              : expandableDetails?.extra_data?.json_creation_date
                  ? moment(expandableDetails?.extra_data?.json_creation_date).format("DD/MM/YY")
                  : "--";

          const title =
        el.dataIndex === "updated_value"
            ? `${el.title} (${json_update_creation_date})`
            : el.dataIndex === "value"
                ? `${el.title} (${json_creation_date})`
                : el.title;

          return { ...el, title };
      });
      let adhoc_para_cols = List([
          {
              s_no: 1,
              parameter: "Sanctioned limit (borrower level)",
              criteria: "--",
              value:
              formatCurrency(expandableDetails?.extra_data?.json_obj["new_sanction_limit"], false) || "--",
              updated_value:
              formatCurrency(expandableDetails?.extra_data?.updated_json_obj[
                  "new_sanction_limit"
              ], false) || "--",
          },
          {
              s_no: 2,
              parameter: "Buyer Status",
              criteria: "Not in overdue/closed",
              value: expandableDetails?.extra_data?.json_obj["buyer_status"] || "--",
              updated_value:
          expandableDetails?.extra_data?.updated_json_obj["buyer_status"] ||
          "--",
          },
          {
              s_no: 3,
              parameter: "Latest disbursal date",
              criteria: "Within Tenor",
              value:
          expandableDetails?.extra_data?.json_obj["latest_disbursal_date"] ||
          "--",
              updated_value:
          expandableDetails?.extra_data?.updated_json_obj[
              "latest_disbursal_date"
          ] || "--",
          },
          {
              s_no: 4,
              parameter: "Adhoc proposed upto max cap",
              criteria: "100%",
              value:
              formatCurrency(expandableDetails?.extra_data?.json_obj["recommended_limit"], false) || "--",
              updated_value:
              formatCurrency(expandableDetails?.extra_data?.updated_json_obj[
                  "recommended_limit"
              ], false) || "--",
          },
          {
              s_no: 5,
              parameter: "Repayment Rotation  >1 times",
              criteria: "TOTAL repayment / sanctioned limit (Case ID) > 1",
              value: expandableDetails?.extra_data?.json_obj["churn"] || "--",
              updated_value:
          expandableDetails?.extra_data?.updated_json_obj["churn"] || "--",
          },
          {
              s_no: 6,
              parameter: "Ageing first disbursal",
              criteria: "90 days and More",
              value:
          expandableDetails?.extra_data?.json_obj["disbursal_vintage"] || "--",
              updated_value:
          expandableDetails?.extra_data?.updated_json_obj[
              "disbursal_vintage"
          ] || "--",
          },
          {
              s_no: 7,
              parameter: "Enhancement Ageing",
              criteria: "90 days and More",
              value:
              expandableDetails?.extra_data?.json_obj["enhancement_vintage"] !== null || 
              expandableDetails?.extra_data?.json_obj["enhancement_vintage"] !== "" ? 
              expandableDetails?.extra_data?.json_obj["enhancement_vintage"] :
                  "--",
              updated_value:
              expandableDetails?.extra_data?.updated_json_obj["enhancement_vintage"] !== null ||
               expandableDetails?.extra_data?.updated_json_obj["enhancement_vintage"] !== "" ?
               expandableDetails?.extra_data?.updated_json_obj["enhancement_vintage"] : "--",
          },
          {
              s_no: 8,
              parameter:"Check for parallel enhancement cases in process",
              criteria:
          "Any new case/enhancement case, above Dc bucket should not be processed.",
              value:
              expandableDetails?.enhancement_case?.enhancement_case !== null ||
               expandableDetails?.enhancement_case?.enhancement_case !== null !== "" ?
               expandableDetails?.enhancement_case?.enhancement_case :
                  "--",
              updated_value:
              expandableDetails?.enhancement_case?.enhancement_case !==null ||
               expandableDetails?.enhancement_case?.enhancement_case !=="" ?
               expandableDetails?.enhancement_case?.enhancement_case : "--",
          },
          {
              s_no: 9,
              parameter: "Max DPD in the past 6 months",
              criteria: "<31 days",
              value: expandableDetails?.extra_data?.json_obj["max_dpd_6m"] !== null ||
               expandableDetails?.extra_data?.json_obj["max_dpd_6m"] !== "" ?
               expandableDetails?.extra_data?.json_obj["max_dpd_6m"] : "--",
              updated_value:
              expandableDetails?.extra_data?.updated_json_obj["max_dpd_6m"] !== null ||
               expandableDetails?.extra_data?.updated_json_obj["max_dpd_6m"] !== "" ?
               expandableDetails?.extra_data?.updated_json_obj["max_dpd_6m"] : "--",
          },
          {
              s_no: 10,
              parameter: "Max DPD in the past 12 months",
              criteria: "<45 days",
              value: expandableDetails?.extra_data?.json_obj["max_dpd_12m"] !==null || 
              expandableDetails?.extra_data?.json_obj["max_dpd_12m"] !== "" ?
               expandableDetails?.extra_data?.json_obj["max_dpd_12m"] : "--",
              updated_value:
              expandableDetails?.extra_data?.updated_json_obj["max_dpd_12m"] !== null ||
               expandableDetails?.extra_data?.updated_json_obj["max_dpd_12m"] !== "" ?
               expandableDetails?.extra_data?.updated_json_obj["max_dpd_12m"] :
                  "--",
          },
          {
              s_no: 11,
              parameter: "Max ageing",
              criteria: "(tenor-20 days)-Max Ageing >=0",
              value: expandableDetails?.extra_data?.json_obj["max_ageing"] !== null || expandableDetails?.extra_data?.json_obj["max_ageing"] !== "" ?
               expandableDetails?.extra_data?.json_obj["max_ageing"] : "--",
              updated_value:
              expandableDetails?.extra_data?.updated_json_obj["max_ageing"] !== null || expandableDetails?.extra_data?.updated_json_obj["max_ageing"] !== "" ?
               expandableDetails?.extra_data?.updated_json_obj["max_ageing"] : "--",
          },
          //   {
          //       s_no: 12,
          //       parameter: "(tenor-20 days)-Max Ageing",
          //       criteria: ">=0",
          //       value:
          //   expandableDetails?.extra_data?.json_obj["reco_db_od_90_plus_prcnt"] ||
          //   "--",
          //       updated_value:
          //   expandableDetails?.extra_data?.updated_json_obj[
          //       "reco_db_od_90_plus_prcnt"
          //   ] || "--",
          //   },
          {
              s_no: 12,
              parameter: "Db portfolio 90+",
              criteria: "<10%",
              value:
              expandableDetails?.extra_data?.json_obj["reco_db_od_90_plus_prcnt"] !== null || 
              expandableDetails?.extra_data?.json_obj["reco_db_od_90_plus_prcnt"] !== "" ?
               expandableDetails?.extra_data?.json_obj["reco_db_od_90_plus_prcnt"] :
                  "--",
              updated_value:
              expandableDetails?.extra_data?.updated_json_obj["reco_db_od_90_plus_prcnt"] !== null || 
              expandableDetails?.extra_data?.updated_json_obj["reco_db_od_90_plus_prcnt"] !== "" ?
               expandableDetails?.extra_data?.updated_json_obj["reco_db_od_90_plus_prcnt"] : "--",
          },
          {
              s_no: 13,
              parameter: "Utilization % (Current-30 days)",
              criteria: "<70%",
              value:
              expandableDetails?.extra_data?.json_obj["buyer_aum_pre_30_days"] !== null ||
               expandableDetails?.extra_data?.json_obj["buyer_aum_pre_30_days"] !== "" ?
               expandableDetails?.extra_data?.json_obj["buyer_aum_pre_30_days"] :
                  "--",
              updated_value:
              expandableDetails?.extra_data?.updated_json_obj["buyer_aum_pre_30_days"] !== null ||
               expandableDetails?.extra_data?.updated_json_obj["buyer_aum_pre_30_days"] !== "" ?
               expandableDetails?.extra_data?.updated_json_obj["buyer_aum_pre_30_days"] : "--",
          },
          {
              s_no: 14,
              parameter: "DB portfolio: No. of Retailer in OD",
              criteria: "<33%",
              value:
              expandableDetails?.extra_data?.json_obj["prcnt_overdue_rt"] !== null || 
              expandableDetails?.extra_data?.json_obj["prcnt_overdue_rt"] !== "" ?
               expandableDetails?.extra_data?.json_obj["prcnt_overdue_rt"] : "--",
              updated_value:
              expandableDetails?.extra_data?.updated_json_obj["prcnt_overdue_rt"] !==null || 
              expandableDetails?.extra_data?.updated_json_obj["prcnt_overdue_rt"] !=="" ?
               expandableDetails?.extra_data?.updated_json_obj["prcnt_overdue_rt"] :
                  "--",
          },
      ]);
      function areAllValuesFilled(obj) {
          for (const key in obj) {
              if (obj[key] === null || obj[key] === undefined) {
                  return false;
              }
          }
          return true;
      }
      const adhocMovementDataApiFn = (prop, expandableDetails) => {
          if (this.state.isSubmitting) {
              return;
          }
          this.setState({ isSubmitting: true });
          if(prop === "proceed" && Number(expandableDetails?.extra_data?.sales_adhoc_create_data[
            expandableDetails?.extra_data?.sales_adhoc_create_data?.length - 1
          ].adhoc_limit_requested ) <=0){
              this.setState({ isSubmitting: false });
              message.error("Requested Adhoc Limit should be >0");
              return;
          }
          let body = {
              action_detail_id: expandableDetails?.id || null,
              action_task_id: expandableDetails?.open_action_task?.id || null,
              action: prop,
              remarks: this.props.adhocPara && this.props.adhocPara["comments"],
          };
          if (prop === "proceed") {
              let facility_limit_sum = 0;
              let facilityObj = this.state.facilityValues;
              const facilityLimitObj = expandableDetails?.extra_data?.json_obj?.facility_id?.split(
                  "|"
              );
              if (facilityLimitObj && facilityLimitObj.length == 1) {
                  facilityObj = {
                      [facilityLimitObj[0]]:
              Number(this.props.adhocPara &&
              this.props.adhocPara["creditApprovedLimit"]?.replace(/^0+/, "")),
                  };
              }
              if (facilityLimitObj && facilityLimitObj?.length > 1) {
                  for (const key in facilityObj) {
                      if (Object.hasOwnProperty.call(facilityObj, key)) {
                          const value = parseFloat(facilityObj[key]); // Convert value to a number
                          if (!isNaN(value)) {
                              facility_limit_sum += value; // Add the value to the sum
                          }
                      }
                  }
                  if (this.props.adhocPara && this.props.adhocPara["caseLimitType"] === "Non-Fungible" && Number(facility_limit_sum) !== Number(this.props.adhocPara && this.props.adhocPara["creditApprovedLimit"])) {
                      message.error(
                          "Sum of Facility level limits should be equal to Credit approved Adhoc Limit"
                      );
                      this.setState({ isSubmitting: false });
                      return;
                  }
              }
              body = {
                  ...body,
                  request_adhoc_limit:
            expandableDetails?.extra_data?.sales_adhoc_create_data[
              expandableDetails?.extra_data?.sales_adhoc_create_data?.length - 1
            ].adhoc_limit_requested,
                  credit_approved_adhoc_limit:
            Number(this.props.adhocPara && this.props.adhocPara["creditApprovedLimit"]?.replace(/^0+/, "")),
                  limit_type:
            this.props.adhocPara && this.props.adhocPara["caseLimitType"],
                  facility_with_limit: facilityObj,
                  adhoc_limit_validity:
            this.props.adhocPara && this.props.adhocPara["adhocLimitVal"],
              };
          }
          if (areAllValuesFilled(body)) {
              CompanyService.adhocMovementDataApi(body)
                  .then((res) => {
                      this.setState({ isSubmitting: false });
                      if (res.status === 200) {
                          this.setState({ isSubmitting: false, facilityValues: {} });
                          message.success(res.data.message || "Updated");
                          this.props.updateState({}, true);
                          this.props.callAdhocListApi();
                      }
                  })
                  .catch(() => {
                      this.setState({ isSubmitting: false, });
                      message.error("Something went wrong");
                  });
          } else {
              this.setState({ isSubmitting: false });
              message.error("Please fill all the fields");
          }
      };
      function calculateUpcomingDate(daysToAdd) {
          const today = new Date(); // Get the current date
          const upcomingDate = new Date(
              today.getTime() + daysToAdd * 24 * 60 * 60 * 1000
          );

          const dd = String(upcomingDate.getDate()).padStart(2, "0");
          const mm = String(upcomingDate.getMonth() + 1).padStart(2, "0"); // January is 0!
          const yy = String(upcomingDate.getFullYear()).slice(-2);
          const formattedUpcomingDate = `${dd}/${mm}/${yy}`;
          return formattedUpcomingDate;
      }
      const getCaseComments = (action_detail_id) => {
          this.setState({ showDrawer: true });
          CompanyService.getCaseComments(action_detail_id).then((res) => {
              const notesData = res.data?.results?.map((el) => ({
                  ...el,
                  create_date: moment(el.create_date),
              }));
              res.status === 200 && this.setState({ getCaseCommentsData: notesData });
          }).catch(()=>{
              message.error("Something went wrong");
          });
      };
      const updateDetailsFn = (case_id) => {
          CompanyService.updateAdhocParameters(case_id).then((res) => {
              if (res.status === 200) {
                  this.props.callAdhocListApi(
                      "",
                      this.props.selectedTab,
                      this.state.page,
                      this.state.page_size
                  );
              }
          }).catch((err)=>{
              message.error( "Something went wrong");
          });
      };
      const getUpcomingDate =
      this.props.adhocPara &&
      this.props.adhocPara["adhocLimitVal"] &&
      calculateUpcomingDate(
          this.props.adhocPara && this.props.adhocPara["adhocLimitVal"]
      ).toString();
      const caseLimitTypeFacility = expandableDetails?.extra_data?.json_obj?.facility_id?.split(
          "|"
      );
      return (
          <Row
              span={24}
              style={{ display: "flex", justifyContent: "space-between" }}
          >
              <Col span={this.props.selectedTab === "myCases" ? 14 : 22}>
                  {this.props.selectedTab !== "myCases" && (
                      <div className="d-flex justify-content-flex-end mb-20">
                          <Button onClick={() => getCaseComments(expandableDetails?.id)}>
                Case Comments
                          </Button>
                      </div>
                  )}
                  <div className="d-flex justify-content-space-between mt-20">
                      <h3>Adhoc Parameters</h3>
                      <a
                          onClick={() =>
                              updateDetailsFn(
                  expandableDetails?.extra_data?.json_obj?.case_id
                              )
                          }
                      >
              Update
                      </a>
                  </div>
                  <Table
                      showTopSection={false}
                      columns={NEW_ADHOC_PARAMETERS_COLS}
                      bordered
                      data={adhoc_para_cols}
                      showFilters={false}
                      showColumnSelector={false}
                      pagination={false}
                      noRowSelection={true}
                  />
              </Col>
              <Drawer
                  title={"Case Comments"}
                  visible={this.state.showDrawer}
                  onClose={() => {
                      this.setState({
                          showDrawer: false,
                      });
                  }}
                  destroyOnClose={true}
                  height={"90vh"}
                  width="500px"
                  closable={true}
                  footer={null}
              >
                  <Row>
                      <Col span={24}>
                          <Row>
                              <Col
                                  span={24}
                                  style={{
                                      flexGrow: 1,
                                      minHeight: "65vh",
                                      maxHeight: "65vh",
                                      overflowY: "auto",
                                  }}
                                  className={"p-5"}
                              >
                                  <Timeline>
                                      {this.state.getCaseCommentsData &&
                                        this.state.getCaseCommentsData
                                            .map((_, k) => {
                                                const item = [_];
                                                return(
                                                    <Timeline.Item key={_.id}>
                                                        {_?.create_date && <div>
                                                            <Tag>
                                                                {_?.create_date?.format("DD-MM-YY") || ""}
                                                            </Tag>
                                                        </div>}
                                                        <SingleDayNotes
                                                            notes={item}
                                                        />
                                                    </Timeline.Item>
                                                );})}
                                  </Timeline>
                              </Col>
                          </Row>
                      </Col>
                  </Row>
              </Drawer>
              {this.props.selectedTab === "myCases" && (
                  <Col span={8}>
                      <div>
                          <div className="d-flex justify-content-flex-end">
                              <Button onClick={() => getCaseComments(expandableDetails?.id)}>
                  Case Comments
                              </Button>
                          </div>
                          <div className="d-flex justify-content-space-between">
                              <h3 className="text-align-center">
                  Adhoc Limit Recommendation
                              </h3>
                          </div>
                          <div>
                              <div className="d-flex justify-content-space-between mt-10">
                                  <h4 style={{ color: "gray", fontWeight: "500", width:"50%" }}>
                    Requested Adhoc Limit (from Sales)
                                  </h4>
                                  <Input
                                      size="large"
                                      disabled
                                      value={
                                          formatCurrency( expandableDetails?.extra_data?.sales_adhoc_create_data[
                        expandableDetails?.extra_data?.sales_adhoc_create_data
                            ?.length - 1
                                          ].adhoc_limit_requested, false) || ""
                                      }
                                      style={{ width: "40%" }}
                                  />
                              </div>
                              <div className="d-flex justify-content-space-between mt-10">
                                  <h4 style={{ color: "gray", fontWeight: "500", width:"50%" }}>
                    Credit approved Adhoc Limit (Basis Credit Assessment)
                                  </h4>
                                  <Input
                                      size="large"
                                      style={{ width: "40%" }}
                                      type="number"
                                      min={1}
                                      value={
                                          (this.props.adhocPara &&
                                            this.props.adhocPara["creditApprovedLimit"]) ||
                      null
                                      }
                                      onChange={(e) =>
                                          this.props.updateState(
                                              { creditApprovedLimit: e.target.value },
                                              false,
                        expandableDetails?.extra_data?.json_obj?.case_id
                                          )
                                      }
                                  />
                              </div>
                              <div className="d-flex justify-content-space-between mt-10">
                                  <h4 style={{ color: "gray", fontWeight: "500", width:"50%" }}>
                    Case Limit Type
                                  </h4>
                                  <Select
                                      style={{ width: "40%" }}
                                      value={
                                          (this.props.adhocPara &&
                        this.props.adhocPara["caseLimitType"]) ||
                      null
                                      }
                                      onSelect={this.props.selectLimitType}
                                  >
                                      <Select.Option value="Fungible">Fungible</Select.Option>
                                      <Select.Option value="Non-Fungible">
                      Non-Fungible
                                      </Select.Option>
                                  </Select>
                              </div>
                              {this.props.adhocPara &&
                  this.props.adhocPara["caseLimitType"] === "Non-Fungible" &&
                  caseLimitTypeFacility.length === 1 && (
                                  <div className="d-flex justify-content-space-between mt-10">
                                      <div className="d-flex justify-content-center align-center text-align-center flex-1">
                                          <span
                                              className="d-flex"
                                              style={{
                                                  color: "gray",
                                                  fontWeight: "500",
                                                  width: "10rem",
                                              }}
                                          >
                          Facility{" "}
                                              {(caseLimitTypeFacility &&
                            caseLimitTypeFacility[0]) ||
                            ""}
                                          </span>
                                      </div>
                                      <Input
                                          size="large"
                                          disabled
                                          style={{ width: "25%" }}
                                          value={
                                              this.props.adhocPara &&
                          this.props.adhocPara["creditApprovedLimit"]
                                          }
                                      />
                                  </div>
                              )}
                              {this.props.adhocPara &&
                  this.props.adhocPara["caseLimitType"] === "Non-Fungible" &&
                  caseLimitTypeFacility.length > 1 &&
                  expandableDetails?.extra_data?.json_obj?.facility_id
                      ?.split("|")
                      ?.map((el, idx) => {
                          return (
                              <div
                                  key={idx}
                                  className="d-flex justify-content-space-between mt-10"
                              >
                                  <div className="d-flex justify-content-center align-center text-align-center flex-1">
                                      <span
                                          className="d-flex"
                                          style={{
                                              color: "gray",
                                              fontWeight: "500",
                                              width: "10rem",
                                          }}
                                      >
                              Facility {el || ""}
                                      </span>
                                  </div>
                                  <Input
                                      key={idx}
                                      size="large"
                                      style={{ width: "25%" }}
                                      value={this.state.facilityValues[el]}
                                      onChange={(e) =>
                                          this.handleFacilityChange(el, e.target.value)
                                      }
                                  />
                              </div>
                          );
                      })}
                              <div className="d-flex justify-content-space-between mt-10 align-items-center">
                                  <h4 style={{ color: "gray", fontWeight: "500" }}>
                    Adhoc Limit Validity
                                  </h4>
                                  <div className="d-flex justify-content-flex-end align-items-center">
                                      <Input
                                          size="large"
                                          type="number"
                                          max={60}
                                          min={0}
                                          style={{ width: "62%"}}
                                          value={
                                              (this.props.adhocPara &&
                          this.props.adhocPara["adhocLimitVal"]) ||
                        null
                                          }
                                          onChange={(e) =>
                                              this.props.updateState(
                                                  { adhocLimitVal: e.target.value },
                                                  false,
                          expandableDetails?.extra_data?.json_obj?.case_id
                                              )
                                          }
                                      />
                                      <span>Days</span>
                                  </div>
                              </div>
                              <p
                                  style={{
                                      textAlign: "end",
                                      margin: "7px 1.2rem 0 0",
                                      fontSize: "13px",
                                  }}
                              >
                                  {getUpcomingDate && getUpcomingDate}
                              </p>
                              <TextArea
                                  className="mt-10"
                                  rows={2}
                                  value={
                                      (this.props.adhocPara &&
                      this.props.adhocPara["comments"]) ||
                    null
                                  }
                                  onChange={(e) =>
                                      this.props.updateState(
                                          { comments: e.target.value },
                                          false,
                      expandableDetails?.extra_data?.json_obj?.case_id
                                      )
                                  }
                              />
                          </div>
                          <div className="d-flex justify-content-space-between mt-10">
                              <Button
                                  type="primary"
                                  disabled={this.state.isSubmitting}
                                  onClick={() =>
                                      adhocMovementDataApiFn("proceed", expandableDetails)
                                  }
                              >
                  Send for FI approval
                              </Button>
                              <Button
                                  type="primary"
                                  disabled={this.state.isSubmitting}
                                  onClick={() =>
                                      adhocMovementDataApiFn("refer", expandableDetails)
                                  }
                              >
                  Refer back to Sales
                              </Button>
                              <Button
                                  type="primary"
                                  disabled={this.state.isSubmitting}
                                  onClick={() =>
                                      adhocMovementDataApiFn("reject", expandableDetails)
                                  }
                              >
                  Reject
                              </Button>
                          </div>
                      </div>
                  </Col>
              )}
          </Row>
      // )
      );
  };
  expandIcon = ({ expanded, onExpand, record }) => {
      if (this.props.selectedTab != "preApproved") {
          return (
              <span
                  onClick={(e) => onExpand(record, e)}
                  className={`ant-table-row-expand-icon ant-table-row-${
                      expanded ? "expanded" : "collapsed"
                  }`}
              />
          );
      } else {
          return null;
      }
  };
  onPageSizeChange = (page, page_size) => {
      this.props.callAdhocListApi("", this.props.selectedTab, page, page_size);
      //   this.setState({ page, page_size });
  };
  onPageChange = (page, page_size) => {
      this.props.callAdhocListApi("", this.props.selectedTab, page, page_size);
      //   this.setState({ page, page_size });
  };
  onExpandFn = (rowOpenBool, row) => {
      this.setState({ expandedRow: row, facilityValues:{} });
      this.props.updateState({}, true);
  };
  render() {
      const userPermissions = (this.props.permissions.get("page_adhoc_edit") && this.props.permissions.get("page_adhoc_bulk_assign"));
      return (
      <>
        {this.assignCasesModal()}
        {this.openCasesModal()}
        <Table
            columns={this.state.columns}
            // bordered
            loading={this.props.loading}
            spanConfig={{
                btnSpan: 12,
            }}
            custonButtonIcons={[]}
            customButtonTexts={["Assign"]}
            showCustomButton={this.selectedRows.size}
            onCustomButtonClicks={[this.handleAssignCaseModal]}
            onExpand={this.onExpandFn}
            expandedRowRender={this.props.selectedTab != "preApproved" &&  this.expandedRowRender}
            data={this.props.data}
            bulkActionSelectedKey={
                this.props.showAssign ? "action_task_id" : "id"
            }
            selectedRowKeys={this.selectedRows}
            showColumnSelector={false}
            noRowSelection={!(this.props.showAssign && userPermissions)}
            onRowSelection={this.onRowSelection}
            hideColumnFiltersModal
            onFilter={this.props.onFilter}
            showFilters
            keyFilter={this.props.showAssign ? "action_task_id" : "id"}
            pagination={{
                defaultPageSize: 10,
                current: this.props.page || this.state.page,
                pageSize: this.props.pageSize || this.state.page_size,
                total: this.props.tabCount,
                defaultCurrent: 1, 
                size: "small",
                count: this.props.data.size,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50", "100"],
                position: "bottom",
                onChange: (page, pageSize) => this.onPageChange(page, pageSize),
                onShowSizeChange: this.onPageSizeChange,
            // total: 30
            }}
            expandIcon={this.expandIcon}
            className={"inbox-table"}
        />
      </>
      );
  }
}
AdhocTable.propTypes = {
    columns: PropTypes.object,
    data: PropTypes.array,
    showAssign: PropTypes.bool,
    userId: PropTypes.string,
    usersList: PropTypes.array,
    updateTable: PropTypes.func,
    loading: PropTypes.bool,
    updateState: PropTypes.func,
};
AdhocTable.defaultProps = {
    showAssign: false,
    userId: "",
    usersList: [],
    loading: false,
};

export default AdhocTable;
